<template>
    <div class="codics-aonaer-info-sys-threejs-body">
        <WebHeader></WebHeader>
        <BreadCrumb :bread-list="breadList" style="margin-top:100px;"></BreadCrumb>
        <div class="codics-aonaer-info-sys-threejs-box">
            <div class="codics-aonaer-info-sys-threejs-container">
                <div class="codics-aonaer-info-sys-threejs-item" v-for="(item, index) in bookList" :key="index">
                    <div class="codics-aonaer-info-sys-threejs-item-card" :data-title="item.name">
                        <el-image class="codics-aonaer-info-sys-threejs-item-himg" :src="initImg(item.logo)"
                            fit="fill"></el-image>
                        <el-image class="codics-aonaer-info-sys-threejs-item-qr-img" :src="item.qrImg"
                            fit="fill"></el-image>
                        <div class="codics-aonaer-info-sys-threejs-item-qr-btn" @click="jumpToWeb(item)">点击电脑查看</div>
                    </div>
                </div>
            </div>
        </div>
        <WebFooter></WebFooter>
    </div>
</template>

<script>
import WebHeader from '@/components/WebHeader';
import WebFooter from '@/components/WebFooter';
import BreadCrumb from '@/components/BreadCrumb';
import { listModel } from '@/api/index3';
import QRCode from 'qrcode';
export default {
    data() {
        return {
            breadList: [
                {
                    title: '网站首页',
                    url: '#'
                },
                {
                    title: '奥纳尔',
                    url: '#'
                },
                {
                    title: '工厂模型',
                    url: '#'
                }
            ],
            bookList: [],
            pageSize: 10,
            pageNum: 1,
            total: 0
        }
    },
    mounted() {
        this.listModelFuc();
    },
    methods: {
        jumpToWeb(item) {
            window.open('https://threejs.katihuo.com/zhanshi/' + item.id, "_blank");
        },
        initImg(str) {
            return str == '' ? '' : ('https://cdn.bosscaigou.com/' + str.split(',')[0]);
        },
        async creatQrCode(item, idx) {   // QRlink是二维码的内容
            console.log(item, idx)
            let _this = this;
            let opts = {
                errorCorrectionLevel: "L",//容错级别
                type: "image/png",//生成的二维码类型
                quality: 0.3,//二维码质量
                margin: 1,//二维码留白边距
                width: 100,//宽
                height: 100,//高
                text: item,//二维码内容
                color: {
                    dark: "#000",//前景色
                    light: "#fff"//背景色
                }
            };
            QRCode.toDataURL(item, opts, (err, url) => {
                if (err) throw err
                //将生成的二维码路径复制给data的QRImgUrl
                // console.log(url)
                _this.bookList[idx].qrImg = url;
            })
        },
        async listModelFuc() {
            let data = await listModel({
                id: 4
            })
            if (data.code == 200) {
                this.bookList = data.data;
                this.bookList.forEach((item, index) => {
                    this.creatQrCode('https://threejs.katihuo.com/zhanshi/' + item.id, index);
                });
            } else {
                this.$message.error(data.message);
            }
        },

    },
    components: {
        WebHeader,
        WebFooter,
        BreadCrumb
    }
}
</script>

<style>
.codics-aonaer-info-sys-threejs-body {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
}

.codics-aonaer-info-sys-threejs-box {
    height: fit-content;
    min-height: calc(100vh - 354px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 40px 0;
}

.codics-aonaer-info-sys-threejs-container {
    height: 100%;
    width: 100%;
    max-width: 1360px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
    padding: 0 5px;
}

.codics-aonaer-info-sys-threejs-item {
    height: 270px;
    width: 33.33333%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 15px;
}

.codics-aonaer-info-sys-threejs-item-card {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    border-radius: 5px;
    overflow: hidden;
    box-sizing: border-box;
    cursor: pointer;
    border: 1px solid #DDD;
    transition: all.3s;
}

.codics-aonaer-info-sys-threejs-item-card img {
    transition: .3s;
}

.codics-aonaer-info-sys-threejs-item-card:hover img {
    transform: scale(1.1);
}

.codics-aonaer-info-sys-threejs-item-card:hover:before {
    opacity: 1;
}

.codics-aonaer-info-sys-threejs-item-himg {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-threejs-item-card::after {
    content: attr(data-title);
    height: 56px;
    width: 100%;
    position: absolute;
    margin: auto;
    bottom: 0;
    left: 0;
    line-height: 56px;
    text-align: center;
    font-size: 14px;
    color: #FFF;
    transition: all .3s;
    background: linear-gradient(to top, rgba(0, 0, 0, .55), rgba(0, 0, 0, 0));
}

.codics-aonaer-info-sys-threejs-item-card::before {
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, .55);
    transition: all .3s;
    z-index: 1;
    opacity: 0;
}

.codics-aonaer-info-sys-threejs-item-qr-img {
    height: 70px;
    width: 70px;
    position: absolute !important;
    margin: auto;
    top: -70px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    opacity: 0;
    transition: all.3s;
    ;
}

.codics-aonaer-info-sys-threejs-item-qr-img img {
    transform: unset !important;
}

.codics-aonaer-info-sys-threejs-item-qr-btn {
    height: 40px;
    width: fit-content;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: -150px;
    z-index: 3;
    color: #FFF;
    font-size: 14px;
    line-height: 40px;
    text-align: center;
    background: #ea5b18;
    box-sizing: border-box;
    padding: 0 30px;
    border-radius: 20px;
    opacity: 0;
    transition: all.3s;
}

.codics-aonaer-info-sys-threejs-item-qr-btn::before{
    content: '扫码手机浏览分享';
    height: 100%;
    width: 100%;
    position: absolute;
    margin: auto;
    top: -100px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 33;
    color: #FFF;
    font-size: 14px;;
    transition: all .3s;
    opacity: 0;
}

.codics-aonaer-info-sys-threejs-item-card:hover .codics-aonaer-info-sys-threejs-item-qr-img {
    opacity: 1;
}

.codics-aonaer-info-sys-threejs-item-card:hover .codics-aonaer-info-sys-threejs-item-qr-btn::before {
    opacity: 1;
}

.codics-aonaer-info-sys-threejs-item-card:hover .codics-aonaer-info-sys-threejs-item-qr-btn {
    opacity: 1;
}
</style>